import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { v4 as uuidv4 } from 'uuid'
import { UcManagementService } from '../../services/usercentrics-consent-manager/uc-management.service'
import { UcService } from '../../enums/uc-service'
import { MbConstants } from '../../../shared/mb-constants'
import { BehaviorSubject } from 'rxjs'
import { CmsLinkType } from '../../enums/cms-link-type'
import { MovingImageService } from '../../services/moving-image/moving-image.service'

@Component({
  selector: 'mb-uc-blocked-content-replacer',
  templateUrl: './uc-blocked-content-replacer.component.html',
  styleUrls: ['./uc-blocked-content-replacer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UcBlockedContentReplacerComponent implements OnInit {

  @Input() ucId: string | undefined
  @Input() ucServiceId: string | undefined
  @Input() componentType: string | undefined
  @Input() useBasicThumbnail: boolean = false
  @Input() ucService: string | undefined
  @Output() isAccepted: EventEmitter<boolean> = new EventEmitter<boolean>()

  id: string
  buttonText$ = new BehaviorSubject<string>('')

  constructor (private ucManagementService: UcManagementService,
               private movingImageService: MovingImageService) {
    this.id = uuidv4()
  }

  ngOnInit (): void {
    if (!this.ucService) {
      // eslint-disable-next-line no-console
      console.debug('No UC service configured for blocked content: ', this.ucService)
    }
    if (!this.ucId) {
      // eslint-disable-next-line no-console
      console.debug('No ID configured for blocked content: ', this.ucId)
    }

    switch (this.ucService) {
      case UcService.FRESH_CHAT: {
        this.buttonText$.next(MbConstants.UC_CHAT_ACCEPT_BUTTON)
        break
      }
      case UcService.MOVING_IMAGE: {
        this.buttonText$.next(MbConstants.UC_MI_ACCEPT_BUTTON)
        break
      }
      default: {
        this.buttonText$.next(MbConstants.UC_DEFAULT_ACCEPT_BUTTON)
        break
      }
    }
  }

  acceptService () {
    this.isAccepted.emit(true)
    this.ucManagementService.acceptService(this.ucServiceId)
    if(this.ucService === UcService.MOVING_IMAGE) {
      this.movingImageService.enableMiAnalytics()
    }
  }

  openUcService () {
    this.ucManagementService.openUCServiceInfo(this.ucServiceId)
  }

  protected readonly cmsLinkType = CmsLinkType
}
